<p-dialog [modal]="true" [(visible)]="isVisible" [style]="{ maxWidth: '90vw', width: '28rem' }" [showHeader]="false"
    (onHide)="this.onClose.emit(true);">
    <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-item">
            <label for="organization" class="font-semibold w-1/4">Organization</label>
            <input pInputText id="organization" formControlName="organization" class="primary" autocomplete="off"
                placeholder="Boldheart" />
        </div>
        <div class="form-item">
            <label for="expiresOn" class="font-semibold w-1/4">Expires on</label>
            <p-calendar inputId="expiresOn" [showTime]="false" appendTo="body" [minDate]="minDate"
                formControlName="expiresOn" dateFormat="dd/mm/yy" />
            <div class="suggestions">
                <div (click)="setTrial()">Trial (7 days)</div>
                <div (click)="set6Months()">6 Months</div>
                <div (click)="set1Year()">1 Year</div>
            </div>
        </div>

        <div class="form-item">
            <div class="code-label">
                <label for="code" class="font-semibold w-1/4">Access code *</label>
                @if (!isEdit) {
                <span class="gen" (click)="generateCode()">Auto-generate</span>
                }
            </div>
            <input pInputText id="code" formControlName="code" class="flex-auto" autocomplete="off" />
            <small id="phone">Your code cannot be changed after you create it.</small>
        </div>
        <div class="btn-container">

            <p-button type="submit" [label]="isEdit?'Update':'Create code'" severity="primary" [disabled]="form.invalid"
                class="flex-grow-1" styleClass="w-full" />
            <p-button type="button" label="Cancel" severity="secondary" (click)="isVisible = false" />
        </div>
    </form>
</p-dialog>

<p-toast />